<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

  @import url('https://fonts.googleapis.com/css?family=Roboto+Slab:100,300,400,700');
  @import url('https://fonts.googleapis.com/css?family=Coiny');
  @import url('https://fonts.googleapis.com/css?family=Raleway&display=swap');
  @font-face {
    font-family: 'Martian B Thai';
    src: url('https://cdn.shopify.com/s/files/1/1384/0387/files/MartianBThai-Regular.eot');
    src: url('https://cdn.shopify.com/s/files/1/1384/0387/files/MartianBThai-Regular.eot?#iefix') format('embedded-opentype'),
    url('https://cdn.shopify.com/s/files/1/1384/0387/files/MartianBThai-Regular.woff2') format('woff2'),
    url('https://cdn.shopify.com/s/files/1/1384/0387/files/MartianBThai-Regular.woff') format('woff'),
    url('https://cdn.shopify.com/s/files/1/1384/0387/files/MartianBThai-Regular.ttf') format('truetype'),
    url('https://cdn.shopify.com/s/files/1/1384/0387/files/MartianBThai-Regular.svg#MartianBThai-Regular') format('svg');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Righteous';
    src: url('./assets/fonts/righteous-regular.eot');
    src: url('./assets/fonts/righteous-regular.eot?#iefix') format('embedded-opentype'),
    url('./assets/fonts/righteous-regular.woff2') format('woff2'),
    url('./assets/fonts/righteous-regular.woff') format('woff'),
    url('./assets/fonts/righteous-regular.ttf') format('truetype'),
    url('./assets/fonts/righteous-regular.svg#Righteous-Regular') format('svg');
    font-weight: normal;
    font-style: normal;
  }
#app {
  width: 100%;
  height: 100%;
  position: relative;
}
.text-center{
  text-align: center !important;
}
  *, *::before, *::after{
    box-sizing: border-box;
  }
body {
  width: 100%;
  margin: 0;
  padding: 0 !important;
  background-color: #ffffff;
  overflow: initial!important;
  color: #000;
  font-family: "PingFang SC", Helvetica, 'Avenir',"Microsoft Yahei",Arial, sans-serif,'宋体';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  -webkit-tap-highlight-color: transparent;
}

* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  /* user-select: none; */
}
body, input, textarea, button, select {
  line-height: normal;
}


ul, ol {
  margin: 0;
  padding: 0;
  list-style: none;
}

a {
  color: #000000;
  text-decoration:none;
}

body{
  padding-top: 80px !important;
  overflow-x: hidden !important;
  background-color: #F5F5F5;
}
.body_top{
  padding-top: 80px !important;
}

.pointer{
  cursor: pointer;
}

/* @media only screen and (max-width: 1299px) {
  body{
    padding-top: 80px !important;
  }
}
@media only screen and (max-width: 767px) {
  body{
    padding-top: 98px !important;
  }
}
@media only screen and (max-width: 479px){
  body{
    padding-top: 94px !important;
  }
} */
@media only screen and (max-width: 990px) {
  body{
    padding-top: 90px !important;
  }
}

::-webkit-scrollbar {
  width: 5px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

</style>




// WEBPACK FOOTER //
// src/App.vue